export default __webpack_public_path__ + "static/media/showroom27.0698b1ad.webp";